export default __webpack_public_path__ + "static/media/3.7ce5ce34.png";